import { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ArtifactTable from '../ArtifactTable';
import DownloadReportButton from '../DownloadReportButton';
import { SendTabProps } from '../ReportDialog.props';
import { formatWhen } from '../ReportDialog.utils';

const SendTab: FC<SendTabProps> = ({
  columns,
  rows,
  day,
  recipients,
  isSent,
  isFinalized,
  isSending,
  onSend,
  canDownloadReport,
  isDownloadingDocuments,
  onDownload,
}) => (
  <Box data-testid="daily-nav-report-send">
    <ArtifactTable columns={columns} rows={rows} />
    <Box mt={2}>
      <Typography variant="body2">
        Recipients: {recipients.length ? recipients.join(', ') : 'None configured'}
      </Typography>
      {isSent ? (
        <>
          <Typography variant="body2" mt={1} data-testid="daily-nav-sent-by">
            Sent by {day?.sent_by_name || 'Unknown'}
          </Typography>
          <Typography variant="body2" mt={1} data-testid="daily-nav-sent-at">
            Sent at {formatWhen(day?.sent_at)}
          </Typography>
        </>
      ) : (
        <Button
          data-testid="daily-nav-send-button"
          variant="contained"
          sx={{ mt: 1, textTransform: 'none' }}
          disabled={!isFinalized || isSending}
          onClick={onSend}>
          Send report
        </Button>
      )}
      {canDownloadReport && (
        <DownloadReportButton isDownloading={isDownloadingDocuments} onClick={onDownload} />
      )}
    </Box>
  </Box>
);

export default SendTab;
